<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Facebook Ads Masterclass' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/facebook_ads_masterclass_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h3" style="line-height: 1.5;" >

        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <!-- INTRO -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        What make Facebook Ads successful
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0" >
                        
What really makes ads convert:
<br>1. Compelling offer: this is the foundation
<br>2. The right targeting: creating the right audience
<br>3. The right messaging: hook and story
<br>4. Eye-catching creatives: the #1 attention grabber and must match ad copy
<br>5. Clear and strong CTAs: call them to action, they don’t do it by themselves
<br>6. Urgency: limited time offers and scarcity give people the push they need
<br><br>
Let’s break them down one at a time.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- INTRO -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        1. Compelling sales offer
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion1">
                        
If you don’t have a GREAT offer, you’ll always struggle to make sales!
<br><br>
However, this part is covered in our business accelerator so you can just circle back to that if you haven’t done that already.
<br><br>
One thing I would like to mention is that the one size fits all does not work. And that reason why it doesn’t necessarily work with your Facebook ads is <strong>compliance</strong>.
<br><br>
You need to tailor your offer so it’s compliant with Facebook Standards. And this is usually a thing that is neglected because people just want to launch the ads and make money. However, this is one of the biggest things that will hold you back.
<br><br>
Every time your ads get disapproved, your disapproval ratio goes up and you progress on this scale, until they shut down your ad account.
<br><br>
This is actually something that people don’t know or often forget: Facebook, like most ad platforms, is based on a bidding algorithm and that is affected by the disapproval ratio.
<br><br>
The more your ads get disapproved and your ratio goes up, your cost also goes up and you will end up paying more for people to actually see your ad.
<br><br>
You also need to tailor the offer so it converts: the copy, the messaging, avatar or get more detailed with the audience so more people are interested in your offer and eventually get more conversions. 

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
                    
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-2 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        2.The right targeting
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion2" > {{ calculateRead('accordion2') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion2">
                        
Creating the right audience or avatar is another key element that is covered in detail in the Business Accelerator.
<br><br>
So make sure you have your avatars set up and create your Facebook audiences based on those interests. And make sure you don’t skip this part.
<br><br>
You need to target the right audience for your product, otherwise you will have a hard time selling your product.
<br><br>
This is a very common mistake people make: they try to sell to everybody and end up selling to nobody.
<br><br>
This is actually the foundation of advertising, or you could say the definition: <strong>getting the right product in front of the right people</strong>.
<br><br>
And this brings us to the third element.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
                    
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-3 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        3.The right messaging
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion3" > {{ calculateRead('accordion3') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-3"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion3">
                        
Getting the right product in front of the right people is not always enough. It may work with some products that are a necessity for everyday life, like a refrigerator, AC in the summer, but most of the time, you need strong copy: a hook and a story.
<br><br>
A hook is the attention grabber and is most of the time the headline, or the first element they see in your ad. If the hook doesn’t grab attention, the reader will scroll away and most likely never come back.
<br><br>
That’s the job of the headline: to get attention and to invite the reader into the story, aka the ad copy.
<br><br>
And when we are talking about ad copy, there are a couple of things you need to focus on.
<br><br>
And this is actually another very common mistake people make: they try to sell product features. But nobody wants to read that, people are not interested in that. 
<br><br>
People buy based on emotion and in order to do that, you need to sell the product benefits, which is what the product does for them.
<br><br>
We cover this in great detail in our copywriting masterclass, so make sure you check them out if you haven’t done that already.
<br><br>
What I want to mention here is compliance: make sure you tailor your messages so they are compliant with Facebook Standards.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-4 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        4. Eye-catching creatives
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion4" > {{ calculateRead('accordion4') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-4"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion4">
                        
This is probably the most important part as a lot of people scan the website and scroll away. So the attention-grabbing is mostly done by creatives.
<br><br>
All these elements are connected with one another. You cannot have great copy and great creatives if you don’t have a great story. And you cannot have a great hook and great story, if you have a bad offer.
<br><br>
If you don’t have a great hook to capture people’s attention, they won’t get to read to copy, no matter how great it is.
<br><br>
And you need a great hook and copy in order to have great creatives.
<br><br>
An important note is that your ad creatives must match your ad hook or headline.


                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-5 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        5. Clear and strong CTAs
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion5" > {{ calculateRead('accordion5') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-5"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion5">
                        
People don’t usually take action by themselves, you need to challenge them to take action.
<br><br>
Also your message must be clear. If it’s not clear what you want your readers to do, they won’t take any action.
<br><br>
Create clear, strong, bold CTAs that challenge readers to take action and click on your ad.
<br><br>
After that, it’s the sales page’s job to do the selling.
<br><br>
A good rule of thumb is to use the headline as the CTA.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-5 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        6. Urgency
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion6" > {{ calculateRead('accordion6') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-6"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion6">
                        
Sometimes, having a great hook, copy and a strong CTA won’t do the job. When that happens, adding urgency can give people the extra push they need to convert.
<br><br>
It can be a time limited offer, limited supply, limited seats, anything that has scarcity.
<br><br>
The FOMO or Fear of Missing Out will push people over the edge.
<br><br>
Now that we know what makes a Facebook Ad successful, let’s see what elements we need to create one.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
        
          </div>
        <!-- ACADEMY -->

        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_page",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: `
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
              richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
              brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
              tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
              assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
              wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
              vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
              synth nesciunt you probably haven't heard of them accusamus labore VHS.
            `
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/facebook-ads-masterclass/02.vue